import commu from '../assets/commu.jpg'
import java from '../assets/java.png'
import reactjs from '../assets/reactjs.png'
import tsjs from '../assets/tsjs.png'
import problemsolver from '../assets/problemsolver.jpg'
import dsa from '../assets/dsa.jpg'

export const listitems = [{    id:0,
                        skillName: "Typescript",
                        srcc: tsjs
                    },
                    {    id:1,
                        skillName: "Java",
                        srcc: java
                    },
                    {   id:2,
                        skillName: "React Js [MERN]",
                        srcc:  reactjs
                    },
                    {   id:3,
                        skillName: "Problem-solver",
                        srcc:  problemsolver
                    },
                    {   id:4,
                        skillName: "OOPS & DSA",
                        srcc:  dsa
                    },
                    {   id:5,
                        skillName: "Communication",
                        srcc:  commu
                    }
                   ]